import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useGodMode } from "@/hooks/useGodMode";
import { setWindowTitle } from "@/lib/window-title";
import { useEffect, useMemo, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

export default function AdministrationPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const isGodMode = useGodMode();

  const [activeTab, setActiveTab] = useState<string>("search");

  const tabList = useMemo(() => {
    const tabs: { label: string; value: string; className?: string }[] = [
      {
        label: "Équipes",
        value: "teams",
      },
      {
        label: "Utilisateurs",
        value: "users",
      },
      {
        label: "Activité utilisateurs",
        value: "users-history",
      },
    ];

    if (isGodMode) {
      tabs.push({
        label: "God Board",
        value: "god-board",
        className: "god-mode-tab",
      });
    }

    return tabs;
  }, [isGodMode]);

  const handleTabChange = (value: string) => {
    setActiveTab(value);
    navigate(value);
  };

  useEffect(() => {
    const paths = location.pathname.replace("/administration", "").split("/");
    if (paths.length <= 1) {
      navigate("teams");
      return;
    }

    setActiveTab(paths.pop() ?? "teams");
  }, [location.pathname, activeTab]);

  useEffect(() => {
    setWindowTitle(
      tabList.find((tab) => tab.value === activeTab)?.label || "Administration"
    );
  }, [activeTab]);

  return (
    <>
      <Tabs value={activeTab} onValueChange={handleTabChange}>
        <TabsList className="justify-start w-full">
          {tabList.map((tab) => (
            <TabsTrigger
              key={tab.value}
              value={tab.value}
              className={tab.className}
            >
              {tab.label}
            </TabsTrigger>
          ))}
        </TabsList>
      </Tabs>

      {/* Under the header and the tab bar (`TabsList`, h-9). */}
      <div className="absolute top-[calc(var(--app-header-height)+2.25rem+1px)] left-0 flex-1 w-full h-[calc(100%-var(--app-header-height)-2.25rem-1px)] overflow-auto">
        <Outlet />
      </div>
    </>
  );
}
